import { MessagingPlatform } from '@this+that/models';

import { resolveGoogleConnectErrorKey } from './googleConnectRefusal';
import { resolveMicrosoftConnectErrorKey } from './microsoftConnectRefusal';

// The mailbox callbacks name their provider as the OAuth redirect brought it back.
export const resolveEmailConnectErrorKey = (
  provider: string | null | undefined,
  error: unknown,
  fallbackKey: string,
): string =>
  provider === MessagingPlatform.OUTLOOK
    ? resolveMicrosoftConnectErrorKey(error, fallbackKey)
    : resolveGoogleConnectErrorKey(error, fallbackKey);
